var map = {
	"./angpao.webp": 2317,
	"./bonus.webp": 2318,
	"./gpi-rebate-m.webp": 2319,
	"./gpi-rebate.webp": 2320,
	"./hublot-watch-2018.webp": 2321,
	"./hublot-watch-2022.webp": 2322,
	"./iphone-13-pro-max.webp": 2323,
	"./iphone-14-pro-max.webp": 2324,
	"./login-to-m.webp": 2325,
	"./login-to.webp": 2326,
	"./mb.webp": 2327,
	"./mg-rebate-m.webp": 2328,
	"./mg-rebate.webp": 2329,
	"./np.webp": 2330,
	"./pointer.webp": 2331,
	"./pp-rebate-m.webp": 2332,
	"./pp-rebate.webp": 2333,
	"./sadface.webp": 2334,
	"./wallet-m.webp": 2335,
	"./wallet.webp": 2336,
	"./wheel-b.webp": 2337,
	"./wheel-btn.webp": 2338,
	"./wheel-indon-b.webp": 2339,
	"./wheel-indon.webp": 2340,
	"./wheel.webp": 2341
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 726;